/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Tulu3 = ({ color = 'primary', aspectRatio = '632/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Tulu3" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Tulu3, Tulu3 as default };
